import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const Span = styled('span')(mapStylesProp);
